module.exports = __webpack_public_path__ + "static/media/windSpeedForecast.777e006f.png";